export const LastAppointmentSvg = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
    <rect x="0.5" width="16" height="16" rx="3" fill="#161618" />
    <path
      d="M12.0938 5.97852H9.59375V4.875C9.59375 4.70215 9.4541 4.5625 9.28125 4.5625H5.29688V4.17188C5.29688 4.12891 5.26172 4.09375 5.21875 4.09375H4.67188C4.62891 4.09375 4.59375 4.12891 4.59375 4.17188V11.8281C4.59375 11.8711 4.62891 11.9062 4.67188 11.9062H5.21875C5.26172 11.9062 5.29688 11.8711 5.29688 11.8281V9.25H7.71875V10.3535C7.71875 10.5264 7.8584 10.666 8.03125 10.666H12.0938C12.2666 10.666 12.4062 10.5264 12.4062 10.3535V6.29102C12.4062 6.11816 12.2666 5.97852 12.0938 5.97852Z"
      fill="white"
    />
  </svg>
);
